<template>
  <div>
    بدون استفاده
    <!-- <b-card no-body class="overflow-hidden">
      <b-row no-gutters>
        <b-col v-if="question.image" :class="question.image ? `col-md-2` : ``">
          <b-card-img :src="question.image" alt="Image" class="rounded-0"></b-card-img>
        </b-col>
        <b-col :class="question.image ? `col-md-10` : `col-md-12`">
          <b-card-body :title="question.caption">
            <b-card-text ref="textQuestion">
              {{truncate(question.textHtml, 25)}}
            </b-card-text>
          </b-card-body>
          <div class="selected-question">
            <i @click="Clipboard(question.textHtml)" class="fa fa-clipboard fa-lg icon-clipboard"
              aria-hidden="true"></i>
            <b-form-checkbox v-model="question.checked"></b-form-checkbox>
          </div>
        </b-col>
      </b-row>
    </b-card> -->
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    selectText(element) {
      var range;
      if (document.selection) {
        // IE
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
    Clipboard(text) {
      navigator.clipboard.writeText(text);
      this.selectText(this.$refs.textQuestion);
      document.execCommand("copy");
      this.$notify.success(this.$lang.azmoonLang.linkCopy);
    },
    truncate(text, limit, append) {
      if (typeof text !== "string") return "";
      if (typeof append == "undefined") append = "...";
      var parts = text.split(" ");
      if (parts.length > limit) {
        // loop backward through the string
        for (var i = parts.length - 1; i > -1; --i) {
          // if i is over limit, drop this word from the array
          if (i + 1 > limit) {
            parts.length = i;
          }
        }
        // add the truncate append text
        parts.push(append);
      }
      // join the array back into a string
      return parts.join(" ");
    },
  },
};
</script>

<style scope>
.selected-question {
  position: absolute;
  width: 7px;
  top: 5px;
  left: 16px;
}

.icon-clipboard {
  position: absolute;
  left: 13px;
  top: 5px;
  cursor: pointer;
}
</style>
